<template>
    <h1
        :class="
            twMerge(
                ' whitespace-pre-line text-left text-[1.625rem] font-bold leading-[1.5] tracking-[-0.02em] sm:text-[2rem] sm:tracking-[-0.03em] lg:text-[3rem]',
                locale === 'en' && 'leading-[1.2] tracking-[-0.01em]',
                locale === 'ja' && 'leading-[1.3]',
                locale === 'ko' && 'leading-[1.3]',
                $attrs.class,
            )
        "
    >
        <span
            v-if="html && (Array.isArray(html) ? html.length > 0 : true)"
            v-html="htmlPurify(Array.isArray(html) ? html.join('\n') : html)"
        />
        <slot v-else />
    </h1>
</template>

<script setup>
import { twMerge } from "tailwind-merge";
import { htmlPurify } from "~/lib/utils";
const { html = "" } = defineProps({
    html: { type: [String, Array], default: "" },
});
const { locale } = useI18n();
</script>
